import { Chip } from '@mui/material'
import { Lock, EditNote, ForkRight } from '@mui/icons-material'

const CONFIG = {
  APPROVED: { icon: Lock, label: 'APPROVED', color: 'primary', variant: 'filled' },
  DRAFT: { icon: EditNote, label: 'DRAFT', color: 'default', variant: 'outlined' },
  SUBMITTED: { icon: EditNote, label: 'SUBMITTED', color: 'warning', variant: 'filled' },
  DECLINED: { icon: EditNote, label: 'DECLINED', color: 'error', variant: 'outlined' },
  ARCHIVED: { icon: EditNote, label: 'ARCHIVED', color: 'default', variant: 'outlined' },
  ACTIVE: { icon: ForkRight, label: 'SCENARIO', color: 'warning', variant: 'filled' },
  PROMOTED: { icon: Lock, label: 'PROMOTED', color: 'primary', variant: 'filled' },
}

export default function StatusBadge({ status }) {
  const cfg = CONFIG[status] || CONFIG.DRAFT
  const Icon = cfg.icon
  return (
    <Chip
      icon={<Icon sx={{ fontSize: 16 }} />}
      label={cfg.label}
      color={cfg.color}
      variant={cfg.variant}
      size="small"
    />
  )
}
